
import './utils/envPolyfill'; // MUST be first import
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import './index.css';
// @ts-ignore
import { APP_VERSION } from './constants';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error("Root element missing");

// Safety check log with safe env access
const mode = (import.meta.env && import.meta.env.MODE) || 'unknown';
console.log(`KFPPC System Init: v${APP_VERSION} [${mode}]`);

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HashRouter>
        <App />
      </HashRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
